import { render } from "./SustainabilityOverview.vue?vue&type=template&id=9899b8cc&scoped=true"
import script from "./SustainabilityOverview.vue?vue&type=script&lang=js"
export * from "./SustainabilityOverview.vue?vue&type=script&lang=js"

import "./SustainabilityOverview.vue?vue&type=style&index=0&id=9899b8cc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9899b8cc"]])

export default __exports__